import React, { useState } from "react";
import { Modal, Tabs } from "antd";
import {
  useExpenseCategoriesQuery,
  useExpenseSubcategoriesQuery,
  useCreateExpenseCategoryMutation,
  useUpdateExpenseCategoryMutation,
  useDeleteExpenseCategoryMutation,
  useCreateExpenseSubcategoryMutation,
  useUpdateExpenseSubcategoryMutation,
  useDeleteExpenseSubcategoryMutation,
} from "../../Services";
import { ExpenseSubCategory } from "./ExpensesSubCategory";
import { ExpenseCategory } from "./ExpensesCategory";
import { modalTitle } from "../AppUi";

interface ManageExpenseCategoryModalProps {
  open: boolean;
  onClose: () => void;
}

export const ManageExpenseCategoryModal: React.FC<
  ManageExpenseCategoryModalProps
> = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState("categories");

  const { data: categories = [], isFetching: loadingCats } =
    useExpenseCategoriesQuery({ page: 1, limit: 100 }, { enabled: open });

  const { data: subcategories = [], isFetching: loadingSubs } =
    useExpenseSubcategoriesQuery({ page: 1, limit: 100 }, { enabled: open });

  const createCat = useCreateExpenseCategoryMutation();
  const updateCat = useUpdateExpenseCategoryMutation();
  const deleteCat = useDeleteExpenseCategoryMutation();
  const createSub = useCreateExpenseSubcategoryMutation();
  const updateSub = useUpdateExpenseSubcategoryMutation();
  const deleteSub = useDeleteExpenseSubcategoryMutation();

  return (
    <Modal
      title={modalTitle("Manage Expenses")}
      open={open}
      onCancel={onClose}
      footer={null}
      width={780}
      destroyOnClose
    >
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        items={[
          {
            key: "categories",
            label: "Categories",
            children: (
              <ExpenseCategory
                categories={categories}
                loadingCats={loadingCats}
                createCat={createCat}
                updateCat={updateCat}
                deleteCat={deleteCat}
              />
            ),
          },
          {
            key: "subcategories",
            label: "Subcategories",
            children: (
              <ExpenseSubCategory
                categories={categories}
                subcategories={subcategories}
                loadingSubs={loadingSubs}
                createSub={createSub}
                updateSub={updateSub}
                deleteSub={deleteSub}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};
